import React, { useState } from "react"
import withStyles from "react-jss"
import { wave, Finger } from "../../assets"

import {
  SHAKEN,
  STIRRED,
  BUILT_IN_ICE,
  SERVE_UP,
  ON_THE_ROCKS,
  CRUSHED_ICE,
} from "../../utils/helper"
import colors from "../../data/colors"
import { MOBILE_BREAKPOINT } from "../../data/globalStyles"

const styles = {
  container: {
    display: "block",
    marginTop: "1.5rem",
    // zIndex: 2,
    "& > :last-child": {
      justifyContent: "flex-end",
      [`@media only screen and (max-width: ${MOBILE_BREAKPOINT}px)`]: {
        justifyContent: "center",
      },
      marginTop: "3rem",
    },
  },
  row: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    marginTop: "1.5rem",
  },
  text: {
    margin: "0 2rem 0 0",
    fontFamily: "Futura",
    fontWeight: 500,
    fontSize: "calc(14px + (16 - 14) * ((100vw - 300px) / (1600 - 300)))",
    color: colors.black,
    [`@media only screen and (max-width: ${MOBILE_BREAKPOINT}px)`]: {
      width: "100%",
    },
    // width: "100%",
  },
  optionButtonInitial: {
    fontFamily: "Futura",
    fontWeight: 500,
    fontSize: "12px",
    color: colors.black,
    textTransform: "uppercase",
    border: 0,
    borderBottom: `6px solid ${colors.orangeHighlight}`,
    margin: "0.5rem 0.75rem 0.5rem 0",
    padding: "0.5rem",
    cursor: "pointer",
    position: "relative",
    background: "#F6F3F1",
  },
  optionButton: {
    fontFamily: "Futura",
    fontWeight: 500,
    fontSize: "12px",
    color: colors.black,
    textTransform: "uppercase",
    border: 0,
    borderBottom: `6px solid ${colors.orangeHighlight}`,
    margin: "0.5rem 0.75rem 0.5rem 0",
    padding: "0.5rem",
    cursor: "pointer",
    position: "relative",
    overflow: "hidden",
    zIndex: 1,
    background: "#F6F3F1",
    "&:before": {
      content: '" "',
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    "&:after": {
      content: '" "',
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
      left: "50%",
      width: "200%",
      height: "450%",
      transform: "translateX(-50%)",
      backgroundColor: colors.orangeHighlight,
      borderRadius: "45%",
      animation: "fill 1.5s ease-in-out forwards",
      opacity: "0.5",
    },
  },
  shaken: {
    composes: "$optionButtonInitial",
    "&:hover": {
      animationName: "buzz",
      animationDuration: "1s",
      animationFillMode: "forwards",
    },
  },

  stirred: {
    composes: "$optionButtonInitial",
    "&:hover": {
      animationName: "wobbleSkew",
      animationDuration: "1s",
      animationFillMode: "forwards",
    },
  },
  builtInGlass: {
    composes: "$optionButtonInitial",
    "&:hover": {
      animationName: "wobbleTopRight",
      animationDuration: "1s",
      animationFillMode: "forwards",
    },
  },
  serveUp: {
    composes: "$optionButtonInitial",
  },
  onTheRocks: {
    composes: "$optionButtonInitial",
  },
  crushedIce: {
    composes: "$optionButtonInitial",
  },
  mixButton: {
    fontFamily: "Futura",
    fontWeight: 400,
    fontSize: "calc(18px + (20 - 18) * ((100vw - 300px) / (1600 - 300)))",
    color: colors.black,
    border: `3px solid ${colors.orangeHighlight}`,
    borderBottom: `10px solid ${colors.orangeHighlight}`,
    backgroundColor: colors.resultBackground,
    marginRight: "1rem",
    padding: "0.5rem",
    cursor: "pointer",
  },
  minButtonError: {
    animationName: "buzz",
    animationDuration: "1s",
    animationFillMode: "forwards",
  },
  "@global": {
    "@keyframes fill": {
      from: {
        top: "35px",
        transform: "translateX(-50%) rotate(0deg)",
      },
      to: {
        top: "-10px",
        transform: "translateX(-50%) rotate(360deg)",
      },
    },
    "@keyframes buzz": {
      "10%": {
        transform: "translateX(3px) rotate(2deg)",
      },
      "20%": {
        transform: "translateX(-3px) rotate(-2deg)",
      },
      "30%": {
        transform: "translateX(3px) rotate(2deg)",
      },
      "40%": {
        transform: "translateX(-3px) rotate(-2deg)",
      },
      "50%": {
        transform: "translateX(2px) rotate(1deg)",
      },
      "60%": {
        transform: "translateX(-2px) rotate(-1deg)",
      },
      "70%": {
        transform: "translateX(2px) rotate(1deg)",
      },
      "80%": {
        transform: "translateX(-2px) rotate(-1deg)",
      },
      "90%": {
        transform: "translateX(1px) rotate(0)",
      },
      "100%": {
        transform: "translateX(-1px) rotate(0)",
      },
    },
    "@keyframes wobbleTopRight": {
      "16.65% ": { transform: "translate(8px, -8px)" },
      "33.3%": {
        transform: "translate(-6px, 6px)",
      },
      "49.95%": {
        transform: "translate(4px, -4px)",
      },
      "66.6%": {
        transform: "translate(-2px, 2px)",
      },
      "83.25%": {
        transform: "translate(1px, -1px)",
      },
      "100%": {
        transform: "translate(0, 0)",
      },
    },
    "@keyframes wobbleSkew": {
      "16.65%": {
        transform: "skew(-12deg)",
      },
      "33.3%": {
        transform: "skew(10deg)",
      },
      "49.95%": {
        transform: "skew(-6deg)",
      },
      "66.6%": {
        transform: "skew(4deg)",
      },
      "83.25%": {
        transform: "skew(-2deg)",
      },
      "100%": {
        transform: "skew(0)",
      },
    },
  },
  error: {
    fontSize: "12px",
    color: "#D06434",
    fontStyle: "italic",
    backgroundImage: `url(${Finger})`,
    paddingLeft: "25px",
    backgroundSize: "20px",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left",
  },
}

const MixAndServeOptions = ({
  classes,
  mixAndServe,
  errors,
  setErrors,
  setMixType,
  setServeType,
  goToResults,
  setShake,
  shake,
}) => {
  const mixOptions = [SHAKEN, STIRRED, BUILT_IN_ICE]
  const mixClasses = {
    [SHAKEN]: classes.shaken,
    [STIRRED]: classes.stirred,
    [BUILT_IN_ICE]: classes.builtInGlass,
  }
  const serveOptions = [SERVE_UP, ON_THE_ROCKS, CRUSHED_ICE]
  const serveClasses = {
    [SERVE_UP]: classes.serveUp,
    [ON_THE_ROCKS]: classes.onTheRocks,
    [CRUSHED_ICE]: classes.crushedIce,
  }

  return (
    <div className={classes.container}>
      <div className={classes.row}>
        <p className={classes.text}>How is it mixed?</p>
        {mixOptions.map((mixType, i) => (
          <button
            key={i}
            className={mixClasses[mixType]}
            className={
              mixAndServe.mix === mixType
                ? classes.optionButton
                : mixClasses[mixType]
            }
            onClick={() => {
              setErrors((prevState) => ({
                ...prevState,
                mix: false,
              }))
              setMixType(mixType)
            }}>
            {mixType}
          </button>
        ))}
        {errors.mix[0] && <span className={classes.error}>pick one!</span>}
      </div>
      <div className={classes.row}>
        <p className={classes.text}>How is it served?</p>
        {serveOptions.map((serveType, i) => (
          <div
            key={i}
            className={
              mixAndServe.serve === serveType
                ? classes.optionButton
                : serveClasses[serveType]
            }
            onClick={() => {
              setErrors((prevState) => ({
                ...prevState,
                serve: false,
              }))
              setServeType(serveType)
            }}>
            {serveType}
          </div>
        ))}
        {errors.serve[0] && <span className={classes.error}>pick one!</span>}
      </div>
      <div className={classes.row}>
        <div
          className={
            shake
              ? classes.mixButton + " " + classes.minButtonError
              : classes.mixButton
          }
          onClick={() => {
            setShake(false)
            goToResults()
          }}>
          Mix it up!
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(MixAndServeOptions)
